import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9 3h6v12H1V0h6zm1 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1 6a3 3 0 1 0-6 0z",
		clipRule: "evenodd"
	})
});
export default SvgFolderPerson;
